export const CHANGELOG_ROUTE = '/profile/changelog';

export const LAST_SEEN_KEY = 'faircount.changelog.lastSeen';
export const LAST_CONSULTED_KEY = 'faircount.changelog.lastConsulted';
